import { Stack, ListItem } from '@mui/material'
import { styled } from '@mui/system'
import Title from '../Title'

const ChartEl = styled('div')`
  display: flex;
  flex-direction: row;
  height: 100px;
  justify-content: space-around;
  align-items: flex-end;
`

const TimeBarEl = styled('div')`
  width: 100%;
  margin: 1%;
  height: ${props => props.value * 100.0}%;
  background-color: #9FB5FD;
  border-radius: 10px;
  grow: 1;
  
`

function TimeBar({value}) {
  return (
    <TimeBarEl value={value} />
  )
}


export default function DayOfWeekChart({title}) {

  const values = [
    0.1, 0.5, 0.7, 0.8, 1.0, 0.2, 0.3
  ]

  return (
    <>
      <Title>{title}</Title>
      <ChartEl>
        {values.map((x, i) => <TimeBar key={i} value={x}></TimeBar>)}
      </ChartEl>
    </>
  )
}